import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Componentes
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import ItemList from '../../components/ItemList/ItemList';
import FriendlyPhrase from '../../components/FriendlyPhrase/FriendlyPhrase';

// Contextos
import { useToast } from '../../contexts/ToastContext';
import { useLoader } from '../../contexts/LoaderContext';
import { useModal } from '../../contexts/ModalContext';

// API
import { useTesteService } from '../../services/testeServices';

// Estilos
import styles from './testespage.module.css';

function TestesPage() {
    const navigate = useNavigate();
    const { showToast } = useToast();
    const { showModal } = useModal();
    const { showLoader, hideLoader } = useLoader();

    const [testes, setTestes] = useState([]);

    const { listarTestes, deletarTeste } = useTesteService();

    useEffect(() => {
        const carregarTestes = async () => {
            showLoader("Carregando testes");

            try {
                const response = await listarTestes();

                if (response.success) {
                    const testesMapeados = response.data.map(teste => ({
                        id: teste.id,
                        name: teste.nome,
                    }));
                    setTestes(testesMapeados);
                } else {
                    showToast("Erro ao carregar testes", 3000, 'error');
                }
            } catch (err) {
                showToast("Erro ao buscar testes", 3000, 'error');
            } finally {
                hideLoader();
            }
        };

        carregarTestes();
    }, []);

    const handleEditar = (item) => {
        navigate(`/testes/atualizar/${item.id}`);
    };

    const handleExcluir = (item) => {
        showModal(
            `Excluir ${item.name}?`,
            'Essa ação não poderá ser desfeita.',
            async () => {
                showLoader("Excluindo teste");

                try {
                    const response = await deletarTeste(item.id);

                    if (response.success) {
                        setTestes(prev => prev.filter(t => t.id !== item.id));
                        showToast('Teste excluído com sucesso!', 3000, 'success');
                    } else {
                        showToast(response.message || 'Erro ao excluir teste', 3000, 'error');
                    }
                } catch (error) {
                    showToast("Erro ao conectar com o servidor", 3000, 'error');
                } finally {
                    hideLoader();
                }
            },
            () => {
                showToast('Exclusão cancelada.', 2000);
            }
        );
    };

    const handleAdd = () => {
        navigate(`/testes/adicionarTeste`);
    };

    const handleSelecionar = (item) => {
        console.log("Teste selecionado:", item);
    };

    return (
        <div className={styles.TestesPage}>
            <div className={styles.containerTop}>
                <Breadcrumbs />
                <h1 className={styles.title}>Testes Cadastrados</h1>
                <FriendlyPhrase page="testes" />
            </div>

            <div className={styles.containerList}>
                <ItemList
                    items={testes}
                    onAdd={handleAdd}
                    onEdit={handleEditar}
                    onDelete={handleExcluir}
                    onClickItem={handleSelecionar}
                />
            </div>
        </div>
    );
}

export default TestesPage;